import {
    Component,
    Input,
    OnDestroy,
    OnInit,
    ViewEncapsulation,
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { fuseAnimations } from '@fuse/animations';
import { ContractTemplatesService } from 'app/services/contract-templates.service';
import { filter } from 'lodash';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PreviewComponent } from './preview/preview.component';

@Component({
    selector: 'contracts',
    templateUrl: './contracts.component.html',
    styleUrls: ['./contracts.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
})
export class ContractsComponent implements OnInit, OnDestroy {
    @Input() filter: any;
    @Input() id: any;
    @Input() modelName: any;
    @Input() model: any;
    @Input() res_id: any;
    contracts: any;
    contract: UntypedFormGroup;
    showBtn = false as boolean;
    template: any;
    attachments: any;
    searchDialogRef: any;
    private _unsubscribeAll: Subject<any>;
    loading: boolean;

    constructor(
        public _contractService: ContractTemplatesService,
        public _formBuilder: UntypedFormBuilder,
        private _matDialog: MatDialog
    ) {
        this._unsubscribeAll = new Subject();
    }

    ngOnInit(): void {
        this._contractService.getData().subscribe(async (data: any) => {
            if (data) {
                this.contracts = filter(data.docs, ['type', this.filter]);
            }
        });

        this.contract = this._formBuilder.group({
            Contracts: '',
        });

        this.getAttchment();
    }

    setConValue(event: any): void {
        this.template = event;
        this.showBtn = true;
    }

    setData(preview: boolean): void {
        this.loading = true;
        if(this.res_id && this.res_id != '') {
            this.id = this.res_id; 
            this.modelName = 'properties_images';
        }
        this._contractService
            .getPDF(this.template, preview, this.id, this.model, this.modelName)
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(
                (data: any) => {
                    if (preview) {
                        this.openModelPDF(data.file_name);
                        this.loading = false;
                    } else {
                        this.getAttchment();
                    }
                },
                () => (this.loading = false)
            );
    }

    getAttchment(): void {
        this.loading = true;
        if (this.filter === 'Properties') {
            this._contractService
                .getPropertiesAttachments(this.id)
                .pipe(takeUntil(this._unsubscribeAll))
                .subscribe(
                    (data: any) => {
                        this.attachments = data;
                        this.loading = false;
                    },
                    () => (this.loading = false)
                );
        } else {
            let id = this.id;
            let modelName = this.modelName;
            if(this.res_id){
                modelName = 'properties_images';
                id = this.res_id;
            }
            this._contractService
                .getAttachments(id, modelName, true)
                .pipe(takeUntil(this._unsubscribeAll))
                .subscribe(
                    (data: any) => {
                        this.attachments = data;
                        this.loading = false;
                    },
                    () => (this.loading = false)
                );
        }
    }

    openModelPDF(name: any): void {
        this.searchDialogRef = this._matDialog.open(PreviewComponent, {
            panelClass: 'preview-form-dialog',
            data: [this.modelName, this.id, name],
        });
        this.searchDialogRef
            .afterClosed()
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((response: any) => {
                if (response) {
                    // this.filter = {};
                    // this.filter = _.pickBy(response.value, _.identity);
                    // this.dataReload.setValue(null);
                }
        });
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
}
